import { WebPage, WithContext } from 'schema-dts';
import { ORGANIZATION_SCHEMA } from './organizationSchema';

export const REGISTRY_LP_SCHEMA: WithContext<WebPage> = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': 'https://www.zola.com/wedding-registry',
  },
  headline: 'Wedding Registry',
  description:
    'Create your wedding registry. Integrate registries from other sites, link your registry to your wedding website, and make gifting easy for your guests! 24/7 customer support.',
  isPartOf: {
    '@type': 'WebSite',
    name: 'Zola',
    url: 'https://www.zola.com',
  },
  publisher: ORGANIZATION_SCHEMA,
  image: {
    '@type': 'ImageObject',
    url: 'https://zola-web-assets.imgix.net/web-home/vpassets/static-preauth/images/WeddingRegistryLP/V3/Masthead/Desktop/HeroBackground.webp?w=1000',
    width: '1000 px',
    height: '522 px',
  },
};
